export default {
  modal: state => state.modal,
  modalMini: state => state.modalMini,
  currentUserCall: state => state.currentUserCall,
  vuexCallStatus: state => state.vuexCallStatus,
  tmpCurrentCallUser: state => state.tmpCurrentCallUser,
  onModalCloseCallback: state => state.onModalCloseCallback,
  callioResultOptions: state => state.callioResultOptions,
}
